/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteSessionIssuersGet } from "../funcs/remoteSessionIssuersGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RemoteSessionIssuer } from "../models/components/remotesessionissuer.js";
import {
  GetRemoteSessionIssuerRequest,
  GetRemoteSessionIssuerSecurity,
} from "../models/operations/getremotesessionissuer.js";
import { unwrapAsync } from "../types/fp.js";
export type RemoteSessionIssuerQueryData = RemoteSessionIssuer;

export function prefetchRemoteSessionIssuer(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetRemoteSessionIssuerRequest | undefined,
  security?: GetRemoteSessionIssuerSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRemoteSessionIssuerQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRemoteSessionIssuerQuery(
  client$: GramCore,
  request?: GetRemoteSessionIssuerRequest | undefined,
  security?: GetRemoteSessionIssuerSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RemoteSessionIssuerQueryData>;
} {
  return {
    queryKey: queryKeyRemoteSessionIssuer({
      id: request?.id,
      slug: request?.slug,
      issuer: request?.issuer,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function remoteSessionIssuerQueryFn(
      ctx,
    ): Promise<RemoteSessionIssuerQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(remoteSessionIssuersGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRemoteSessionIssuer(
  parameters: {
    id?: string | undefined;
    slug?: string | undefined;
    issuer?: string | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "remoteSessionIssuers", "get", parameters];
}
